import { Injectable, inject } from '@angular/core';
import {ApplicationInsights} from '@microsoft/applicationinsights-web';
import {AngularPlugin} from '@microsoft/applicationinsights-angularplugin-js';
import {Router} from '@angular/router';
import {filter} from 'rxjs/operators';
import {SiteDataService} from "./site-data.service";
import {take} from "rxjs";
import {Environment} from "../models/environment.model";

@Injectable({
    providedIn: 'root',
})
export class ApplicationInsightsService {
    private router = inject(Router);
    private siteDataService = inject(SiteDataService);

    private appInsights : ApplicationInsights;
    private angularPlugin = new AngularPlugin();

    constructor() {
        const siteDataService = this.siteDataService;

        siteDataService.select(c => c.environmentConfig)
            .pipe(filter(c => c != null && (c.applicationInsightsInstrumentationKey?.length ?? 0) > 0), take(1))
            .subscribe(c => {
                if (c.environmentID !== Environment.LOCAL) {
                    this.initialize(c.applicationInsightsInstrumentationKey);
                }
            });
    }

    initialize(instrumentationKey: string): void {
        this.appInsights = new ApplicationInsights({
            config: {
                instrumentationKey: instrumentationKey,
                enableCorsCorrelation : true,
                enableAutoRouteTracking: true,
                extensions: [<any>this.angularPlugin],
                extensionConfig: {
                    [this.angularPlugin.identifier]: {
                        router: this.router,
                    },
                },
            }
        });

        this.appInsights.loadAppInsights();
        this.loadCustomTelemetryProperties();
    }

    setUserId(userId: string) {
        this.appInsights?.setAuthenticatedUserContext(userId);
    }

    clearUserId() {
        this.appInsights?.clearAuthenticatedUserContext();
    }
    logEvent(name: string, properties?: { [key: string]: any }) {
        this.appInsights?.trackEvent({ name: name}, properties);
    }

    logMetric(name: string, average: number, properties?: { [key: string]: any }) {
        this.appInsights?.trackMetric({ name: name, average: average }, properties);
    }

    logException(exception: Error, severityLevel?: number) {
        this.appInsights?.trackException({ exception: exception, severityLevel: severityLevel });
    }

    private loadCustomTelemetryProperties()
    {
        this.appInsights.addTelemetryInitializer(envelope =>
            {
                const item = envelope.baseData;
                item.properties = item.properties || {};
                item.properties["ApplicationPlatform"] = "WEB";
            }
        );
    }

}
